import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Field } from "../shared/helpers/Primitives";
import { PrimaryButton, StyledTabButton } from "../shared/helpers/GlobalStylesv5";
import { tokens } from "../../theme/tokens";

interface Props {
  initialName: string;
  onClose: () => void;
  onAdd: (firstName: string, lastName: string) => void;
}

// Mounted only while open, so each open starts from initialName.
const AddRepresentativeDialog = ({ initialName, onClose, onAdd }: Props) => {
  const [first = "", ...rest] = initialName.trim().split(/\s+/);
  const [firstName, setFirstName] = useState(first);
  const [lastName, setLastName] = useState(rest.join(" "));

  const canAdd = firstName.trim() !== "";
  const handleAdd = () => {
    if (canAdd) onAdd(firstName.trim(), lastName.trim());
  };
  const submitOnEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleAdd();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontSize: tokens.type.denseStrong.size,
          fontWeight: tokens.type.denseStrong.weight,
        }}
      >
        Add new client representative
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: tokens.space[3],
          pt: `${tokens.space[2]} !important`,
        }}
      >
        <Field
          autoFocus
          required
          size="small"
          label="First name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          onKeyDown={submitOnEnter}
        />
        <Field
          size="small"
          label="Last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          onKeyDown={submitOnEnter}
        />
      </DialogContent>
      <DialogActions sx={{ px: tokens.space[4], pb: tokens.space[3], gap: tokens.space[2] }}>
        <StyledTabButton onClick={onClose}>Cancel</StyledTabButton>
        <PrimaryButton onClick={handleAdd} disabled={!canAdd}>
          Add representative
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddRepresentativeDialog;
